import Vue from 'vue'
import VueI18n from 'vue-i18n'
// 从语言包文件中导入语言包对象
import zh from './zh'
import en from './en'
// 语言以 /en/ 路径为准；旧地址的 ?lang=en 继续兼容。SEO 的 hreflang 指向路径。
import { preferredLocale } from '../seo/content.mjs'
Vue.use(VueI18n)
const messages = {
  zh,
  en
}
const i18n = new VueI18n({
  messages,
  locale:
    typeof window === 'undefined'
      ? 'zh'
      : preferredLocale(window.location.search, window.location.pathname),
})
export default i18n
